import type { Ref } from "react";
import { useDraft } from "../state/useDraft";

interface FilterBarProps {
  activeFilter: string;
  inputRef: Ref<HTMLInputElement>;
  onApply(filter: string): void;
}

export function FilterBar({ activeFilter, inputRef, onApply }: FilterBarProps) {
  const [text, setText] = useDraft(activeFilter, activeFilter);

  return (
    <form
      className="filter-bar"
      role="search"
      onSubmit={(event) => {
        event.preventDefault();
        onApply(text.trim());
      }}
    >
      <label className="visually-hidden" htmlFor="filter-input">
        Filter tasks
      </label>
      <input
        id="filter-input"
        ref={inputRef}
        className="text-input"
        spellCheck={false}
        autoComplete="off"
        placeholder="Filter  e.g. project:Work +urgent due:<friday"
        value={text}
        onChange={(event) => setText(event.target.value)}
      />
    </form>
  );
}
